<template>
  <div 
    id="header"
    v-if="slug !== null && slug !== 'error' && projectData"
    class="ProjectExtended">
    <BtnExtend :slug="slug" />

    <HeaderSection 
      wide
      :title="`Verhaal: ${title}`"
      :mediaImageSrc="afbeelding"
      :closeLinkTo="{name: 'project-beknopt', params: { slug }}"
      :mediaLinkTo="{name: 'project-extended', params: { slug }}">
      <SimpleTable :data="tableData" />
    </HeaderSection>

    <ContentSection wide style="margin-bottom: 0">
      <p class="submenu" style="margin-top: 0;margin-bottom: 0">
        <span class="submenu--selected">Tijdlijn</span> |
        <span>Tip, Top, Flop</span> |
        <span>Verbanden</span> |
        <span>Media</span> |
        <span>Contact</span> 
      </p>
    </ContentSection>

    <TimeLineSegment 
      v-for="segment in timeLineSegments" 
      :key="segment.id" 
      :segment="segment" />
 
  </div>
</template>

<script>

import Basis from './ProjectBasis';

import BtnExtend from '@/components/buttons/Extend';
// import SectionHeader from '@/components/section/Header';
import HeaderSection from '@/components/section/HeaderSection';
import ContentSection from '@/components/section/ContentSection';
import TimeLineSegment from '@/components/section/TimeLineSegment';
import SimpleTable from '@/components/content/SimpleTable';
// import ContentVideo from '@/components/content/Video';
// import Tags from '@/components/lists/Tags';
import dynamicSort from '@/helpers/dynamicSort';

export default {
  name: 'ProjectExtended',
  components: {
    BtnExtend,
    // SectionHeader,
    HeaderSection,
    ContentSection,
    TimeLineSegment,
    SimpleTable,
    // ContentVideo,
    // Tags,
  },
  extends: Basis,
  computed: {
    // TODO: Better ordering... !!! -> date else order || order else date
    timeLineSegments() {
      return this.$store.getters.getSegmentHeadersByProjectId({
        id: this.projectData.id
      }).sort(dynamicSort('order'));
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.dispatch('extended_set', { extended: true })
      vm.$store.dispatch('sidepanel_set', { panel: 'TimeLine' })
    })
  },
  beforeRouteLeave (to, from, next) {
    this.$store.dispatch('extended_set', { extended: false })
    this.$store.dispatch('sidepanel_set', { panel: 'PlatformSlider' })
    next();
  }
}
</script>
<style lang="scss">
.submenu {
  font-family: $font_nav;
  color: $gray_mid;

  span {
    display: inline-block;
    color: $antraciet_blauw_medium;
    cursor: pointer;
    margin: 0 8px;

    &:first-child {
      margin-left: 0;
    }
  }
  &--selected {
    color: $antraciet_blauw !important;
  }
}
</style>

